package ui.new_ui.components.loaders.linear_loaders

import react.FC
import react.dom.html.ReactHTML
import ui.new_ui.components.loaders.props.LinearLoaderProps
import ui.new_ui.components.loaders.props.MainLoaderProps
import web.cssom.ClassName


val LinearLoader = FC<LinearLoaderProps> { props->
    if (props.isLoading){
        ReactHTML.span {
            className = ClassName("loader-linear-load")
        }
    }
}